import ContestWinnerManagementV2Module from '@/modules/contest-winner-management-v2';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/fantasy/fixture/contest-winner-management-v2/'
)({
  validateSearch: searchSchema,
  component: ContestWinnerManagementV2Page,
});

function ContestWinnerManagementV2Page() {
  return <ContestWinnerManagementV2Module />;
}
